<template>
  <textarea
    class="form-control"
    id="cms-smart-text-box"
    :style="{ height: pixelHeight + 'px', zIndex: 99999, position: 'relative' }"
    :disabled="loading"
    v-model="text"
    :placeholder="props.placeholder"
    :aria-label="props.label ?? 'text box'"
    rows="3"
    @blur="blur"
    @keydown="keyDown"
  ></textarea>
</template>

<script setup lang="ts">
/* eslint-disable */
import { onMounted, ref } from "vue";
import cms from "../../services/cms/cms";
import { CmsDocumentTypes } from "../../services/cms/cms-type-definitions";
import { getTextBox, saveTextBox as saveTextBox } from "../../stores/smart-text-box-store";
import { TextBoxEntryApiModel } from "api-models";
import { csContext } from "../../services/cs-context";

const props = defineProps<{ uid?: string; placeholder?: string; label?: string }>();

const text = ref<string>("Loading...");
const loading = ref<boolean>(true);
const pixelHeight = ref<number>(100);

function textBoxState(): TextBoxEntryApiModel {
  return {
    authorId: csContext.user.id,
    subjectUserId: csContext.user.id,
    cmsType: "cms-smart-text-box",
    cmsId: "",
    cmsUid: props.uid ?? "",
    text: text.value,
  };
}

const blur = ref(() => saveThrottled(true));
const keyDown = ref((e: KeyboardEvent) => {
  if (e.key === "Enter" || e.key === "!" || e.key === "." || e.key === "?") {
    setTimeout(() => {
      saveThrottled(true);
    }, 100);
  } else {
    setTimeout(() => {
      saveThrottled(false);
    }, 100);
  }
});

let inputTimeout = null;

async function saveThrottled(rerunPrompts: boolean) {
  if (inputTimeout !== null) {
    return;
  }

  inputTimeout = setTimeout(async () => {
    inputTimeout = null;
    await saveTextBox(textBoxState(), rerunPrompts);
  }, 1000) as any;
}

onMounted(async () => {
  if (props.uid) {
    getTextBox(props.uid).then((value) => {
      text.value = value;
      loading.value = false;
    });

    const doc = await cms.getByUid(CmsDocumentTypes.CmsSmartTextBox, props.uid);
    pixelHeight.value = doc.data.height ?? 100;
  }
});

defineExpose({
  text,
});
</script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables.less";

// Make the textarea not have a drag handle
textarea {
  resize: none;
  font-size: 18px;
  border-radius: 5px;
  margin-bottom: 25px;
}
</style>
